var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54757 1.6092C3.54757 2.49866 2.83706 3.21938 1.96013 3.21938C1.0832 3.21938 0.372696 2.49866 0.372696 1.6092C0.372696 0.720383 1.0832 -0.000976562 1.96013 -0.000976562C2.83706 -0.000976562 3.54757 0.720383 3.54757 1.6092ZM3.56037 4.50752H0.359894V14.8126H3.56037V4.50752ZM8.66961 4.50752H5.48961V14.8126H8.67025V9.4031C8.67025 6.39529 12.5294 6.14925 12.5294 9.4031V14.8126H15.7222V8.28757C15.7222 3.21229 10.0112 3.39714 8.66961 5.89549V4.50752Z",
    fill: "currentColor"
  })));
};
export default SvgLinkedin;